import React from 'react'

const Author = () => {
    return (
        <div className='container'>
            <h1>Roadmap for Becoming An Author</h1>
            <p>Just do it. When I learned Python, I wasn’t satisfied with the books I used, so I resolved to write the book I would have liked to learn from. I put in the traditional, basic material but put my own spin on it: things that worked for me and didn’t work, tricks I picked up, etc. I really focused on providing the personal feel to the book, rather than keeping it dry and academic like other programming books.
<br /> <br />
If you’re not a writer, then it can be difficult to even find a starting point. I’d recommend just keeping a log of things that you have learned over the years. Maybe look at other programming books and think of things that you would want to revise about it.
<br /> <br />
Once you have a few pages of thoughts, start writing in a narrative form. Put in the basics of whatever the subject, then expand on those concepts by including your personal experiences, best practices, tips and tricks, etc.
<br /> <br />
Creating examples is a great start too, because you have to explain the code. Imagine writing a book for a middle schooler and “dumb down” the information. Alternatively, make a topic-specific book for intermediate/advanced programmers. There are a lot of programming libraries or concepts that simply don’t have good documentation, much less useful examples of real-life scenarios.</p>
<br /> <br />   

<p> <b><strong>Source</strong></b> <a href="https://www.quora.com/How-can-a-programmer-write-a-programming-book">Cody Jackson </a>   </p>

<br /> <br />
<p>I think the problem I find with most programming books is that either it touches the surface (like idiot's guide) or it is too hard to follow. Einstein had said that one should be able to explain to a 6 year old.</p>
<p>So I think these are my pre-requisites:</p>
<ol>
    <li>The author is a good story teller. We do not have much attention in today's day and age and so the author must give interesting analogies.</li>
    <li>The author should attach links to cool things in the book. The book should have an interactive website.</li>
    <li>For each programming concept, there should be an e.g. where it is used in real life. Like if you are teaching hashtables, tell how social media companies use hash tables.</li>
</ol>
<p> <b><strong>Source</strong></b> <a href="https://www.quora.com/How-can-I-write-excellent-programming-book"> Arindam</a>   </p>
        </div>
    )
}

export default Author
